export const MuiSnackbar = () => ({ root: { '&.MuiSnackbar-anchorOriginTopCenter': { top: '80px' } } });
